import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-scoring-component-entry', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (student_id, Options = {}) => {
  return httpClient
    .get(`/api/student-scoring-entries/${student_id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-scoring-component-entry', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getGradingComponent = (grade_id, sc_bas_id) => {
  return httpClient
    .get(
      `/api/student-scoring-entries/grading-components/${grade_id}/${sc_bas_id}`
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
//
export const getScoringCycle = Options => {
  return httpClient
    .get('/api/student-scoring-entry/scoring/cycle', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
//
export const getSubjectComponentItems = (subject_id) => {
  return httpClient
    .get(`/api/student-scoring-component-entry/subject-component-items/${subject_id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSubjectComponentItemDetails = data => {
  return httpClient
    .put(`/api/student-scoring-component-entry/subject-component-item-details`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/student-scoring-component-entry/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  find,
  destroy,
  getGradingComponent,
  getScoringCycle,
  getSubjectComponentItems,
  getSubjectComponentItemDetails
}
